import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SubjectModel } from 'data/subject/subject.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: SubjectModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<SubjectModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const subjectSlice = createSlice({
  name: 'subject',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default subjectSlice;
